<script setup lang="ts">
defineProps<{
  phoneNumber: string
}>()
</script>

<template>
  <BaseButton
    v-if="phoneNumber"
    :href="`tel:${phoneNumber}`"
    class="flex items-center gap-2"
  >
    <Icon name="ph:phone-duotone" class="size-4" />

    {{ phoneNumber }}
  </BaseButton>
</template>
